export default __webpack_public_path__ + "a98bbfa102096118f70f3d1ba616d16b.png";